(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const articleCarousels = document.querySelectorAll('[data-article-carousel]');
    let articleSwipers = [];
    const buildArticleSwipers = () => {
      articleCarousels.forEach((carousel, i) => {
        articleSwipers[i] = new Swiper(carousel, {
          slidesPerView: 'auto',
          spaceBetween: 30,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          allowTouchMove: true,
          preloadImages: false,
          watchSlidesProgress: true,
          lazy: {
            loadPrevNextAmount: 5,
          },
          breakpoints: {
            320: {},
            480: {},
            1024: {
              allowTouchMove: true,
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            snapOnRelease: true,
            hide: true,
          },
        });
      });
    };
    buildArticleSwipers();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const instaCarousels = document.querySelectorAll('[data-instagram-carousel]');

  let instaSwipers = [];
  const buildInstaSwipers = () => {
    instaCarousels.forEach((carousel, i) => {
      instaSwipers[i] = new Swiper(carousel, {
        slidesPerView: 'auto',
        spaceBetween: 30,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        allowTouchMove: true,
        preloadImages: false,
        watchSlidesProgress: true,
        lazy: {
          loadPrevNextAmount: 5,
        },
        breakpoints: {
          576: {
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,
          },
          1200: {
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          1600: {
            allowTouchMove: true,
            slidesOffsetBefore: 140,
            slidesOffsetAfter: 50,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          snapOnRelease: true,
          hide: true,
        },
      });
    });
  };
  buildInstaSwipers();
});

  } catch(e) { console.error(e); }
})();
})();
